import { contract } from '@repo/api/contract';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import { ApiFetcherArgs, tsRestFetchApi } from '@ts-rest/core';
import apiEnvironment from '@/data/environment';
import { useBullhornSessionContext } from '@/api/BullhornSession';
import { useMemo } from 'react';
import { useToroExtensionVersion } from '@repo/ui/components/ToroExtensionContext';

export { contract };
export type { ClientInferResponseBody, ClientInferRequest } from '@repo/api/contract';
export type TsrContract = typeof contract;

const tsrOptions = {
  baseUrl: apiEnvironment.baseUrl,
  jsonQuery: true,
  baseHeaders: {
    'Toro-Is-Embedded': '' as string,
  },
  api: async (params: ApiFetcherArgs) => {
    return tsRestFetchApi(params);
  },
} as const satisfies Parameters<typeof initTsrReactQuery>[1];

const tsr = initTsrReactQuery(contract, tsrOptions);

// Hook to get a TSR instance with access to the embedded session token, if needed
export function useTsr(): typeof tsr {
  const bullhornSession = useBullhornSessionContext()?.session ?? null;
  const extensionVersion = useToroExtensionVersion();
  return useMemo(() => {
    const sessionToken = bullhornSession?.sessionToken;
    if (!sessionToken && !extensionVersion) return tsr;
    return initTsrReactQuery(contract, {
      ...tsrOptions,
      baseHeaders: {
        ...tsrOptions.baseHeaders,
        ...(sessionToken && {
          Authorization: `Bearer ${sessionToken}`,
          'Toro-Is-Embedded': 'true',
        }),
        ...(extensionVersion && { 'toro-extension-version': extensionVersion }),
      },
    });
  }, [bullhornSession, extensionVersion]);
}
